import React, { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { Button, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import CarrierSZLTForm from './CarrierSZLTForm';
import { PROCEDURE_TYPE } from '../../../../configs';

export default function ApplicationCarrierSzltForm(props) {
  const {
    prefix, disabled, control, watch, selectedProcedure, legalEntityType, formMeta, setValue, numberHelperAction = _ => {
    }, procedure, labelPrefix, getValues, errors,
  } = props;
  const {
    fields, append, remove,
  } = useFieldArray({ control, name: `${prefix}order_services_attach` });

  return (
    <>
      {
        selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1
        || selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5
          ? (
            <div className="form-list-block">
              <div className="form-list-header f4 mt-3">
                <div className="f4">{selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 ? 'Номер в реестре СЗЛТ' : 'Добавить СЗЛТ'} </div>
                <Button
                  variant="link"
                  onClick={() => append({
                    contract_effective_date: null,
                    contract_expiration_date: null,
                    contract_number: null,
                    order_service_contract_files: null,
                    order_service_number: null,
                  })}
                >
                  Добавить запись
                </Button>
              </div>
              {errors?.application_carrier?.order_services_attach?.message ? (<div className="invalid-feedback d-block mt-1">{errors?.application_carrier?.order_services_attach?.message}</div>) : null }
              {fields.map((field, index) => (
                <div className="carrier-szlt-registry mt-3" key={field.id}>
                  <CarrierSZLTForm
                    control={control}
                    formMeta={formMeta}
                    legalEntityType={legalEntityType}
                    procedure={procedure}
                    index={index}
                    prefix={prefix}
                  />
                  <div className="d-flex flex-row align-items-center">
                    <Button className="mt-3 ms-auto btn-link" onClick={() => remove(index)}>Удалить запись</Button>
                  </div>
                </div>
              ))}
            </div>
          ) : null
      }
      <div className="mb-3" />
    </>
  );
}
